import React from "react";
import Section from "../components/sections/Section";

function About() {
  return (
    <div>
      <Section
        title="about"
        description="This webpage was built from scratch with react and figma."
      >
        Rules: All clickable items should have a hover effect
      </Section>
    </div>
  );
}

export default About;
